import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Star, Sparkles, ArrowDownLeft, ArrowUpRight } from 'lucide-react';
export function Hero() {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setStep(prev => (prev + 1) % 3);
    }, 2500);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative pt-[64px] md:pt-[96px] pb-[64px] md:pb-[96px] overflow-hidden bg-bg-primary" data-id="element-130">
      {/* Radial Gradient Background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-[1100px] pointer-events-none" style={{
      background: 'radial-gradient(ellipse 80% 50% at 50% -10%, rgba(0,180,230,0.08) 0%, transparent 70%)'
    }} data-id="element-131" />

      <div className="container mx-auto px-5 max-w-[1100px] relative z-10 flex flex-col items-center text-center" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} className="inline-flex items-center justify-center text-center px-[16px] md:px-[20px] py-[8px] rounded-[100px] bg-accent-glow border border-accent-border text-[10px] md:text-[12px] font-bold text-accent mb-7 md:mb-8 uppercase tracking-[0.06em] md:tracking-[0.08em] animate-glowPulse max-w-[320px] md:max-w-none leading-[1.4]" data-id="element-133">
          ✦ EL SISTEMA #1 QUE USAN LOS AGENTES QUE MÁS VENDEN
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-[36px] md:text-[56px] font-[900] leading-[1.1] mb-6 max-w-[750px] text-white" data-id="element-134">
          Convierte las Fotos de tus Propiedades en{' '}
          <span className="text-accent" data-id="element-135">Videos Profesionales con IA</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-[16px] md:text-[18px] text-text-secondary mb-9 md:mb-10 leading-[1.65] md:leading-[1.7] max-w-[580px] font-[500] px-1" data-id="element-136">
          Con VideoInmo AI produces un video cinematográfico de tu propiedad en
          3 minutos con Inteligencia Artificial — sin diseñadores, sin cámaras,
          sin experiencia previa.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center gap-4 mb-12 md:mb-16 w-full" data-id="element-137">
          <Button href="https://etsdvu-71.myshopify.com/cart/43467725832281:1" className="w-full md:w-auto" data-id="element-138">
            OBTENER ACCESO POR S/49.90 →
          </Button>
          <p className="text-[14px] text-text-secondary font-medium mt-1" data-id="element-139">
            Es un pago unico, con acceso de por vida
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 mt-4 max-w-[340px] sm:max-w-none" data-id="element-140">
            <div className="flex -space-x-2" data-id="element-141">
              {['https://cdn.magicpatterns.com/uploads/veDnBF7nu7Dm6V3GyYsMtc/593542377_2124247001679977_2114310167722025643_n.jpg', 'https://cdn.magicpatterns.com/uploads/nBsqt7D5BKFkJ16Dyn4RTd/695532906_27072320575697130_7208045210679575049_n_(1).jpg', 'https://cdn.magicpatterns.com/uploads/df5Qf2EpWs94y4V3H4VN72/536270285_2659849831015774_6393349587524602476_n.jpg', 'https://cdn.magicpatterns.com/uploads/o44uYggcpdUJ966yLkbppZ/685360805_122099130825291455_5029607388340402011_n.jpg', 'https://cdn.magicpatterns.com/uploads/gMcNZLvBM1AVvUrwY92EHU/79935766_10159180282538626_8161386556251176960_n.jpg'].map((imgUrl, i) => <div key={i} className="w-8 h-8 rounded-full border-2 border-bg-primary overflow-hidden" data-id="element-142">
                  <img src={imgUrl} alt={`Agente ${i + 1}`} className="w-full h-full object-cover" data-id="element-143" />
                </div>)}
            </div>
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left" data-id="element-144">
              <div className="flex gap-0.5" data-id="element-145">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 fill-accent text-accent" data-id="element-146" />)}
              </div>
              <span className="text-[12px] text-text-secondary font-medium leading-snug" data-id="element-147">
                +200 agentes inmobiliarios ya aprendieron a crear sus videos con
                ia
              </span>
            </div>
          </div>
        </motion.div>

        {/* Video Showcase - 3 Step Animation */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative w-full max-w-[900px]" data-id="element-148">
          {/* Floating neon annotation: top-right */}
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 3.2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute z-30 top-3 right-3 md:top-[-20px] md:right-[4%] flex items-center gap-1.5 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-bg-primary/90 backdrop-blur-sm border border-accent text-accent text-[10px] md:text-[13px] font-bold shadow-[0_0_24px_rgba(0,180,230,0.5)] whitespace-nowrap" data-id="element-149">
            ⚡ Hecho en 3 min
            <ArrowDownLeft className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-150" />
          </motion.div>

          {/* Floating neon annotation: bottom-left */}
          <motion.div animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 3.6,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.6
        }} className="absolute z-30 bottom-3 left-3 md:bottom-[-20px] md:left-[4%] flex items-center gap-1.5 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-bg-primary/90 backdrop-blur-sm border border-accent text-accent text-[10px] md:text-[13px] font-bold shadow-[0_0_24px_rgba(0,180,230,0.5)] whitespace-nowrap" data-id="element-151">
            <ArrowUpRight className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-152" />
            📱 Hecho desde el móvil
          </motion.div>

          <div className="w-full aspect-[16/10] md:aspect-video bg-bg-card border border-accent-border rounded-[16px] shadow-[0_0_60px_rgba(0,180,230,0.08)] overflow-hidden relative" data-id="element-153">
            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center" data-id="element-154">
              <motion.div animate={{
              opacity: step === 0 ? 1 : 0,
              scale: step === 0 ? 1 : 0.95
            }} className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-155">
                <img src="https://cdn.magicpatterns.com/uploads/biwvuFqZDaV6Wzw9WJQ53g/imagem-estattica-imoblabs-1024x1024.png" alt="Foto estática" className="absolute inset-0 w-full h-full object-cover opacity-80" data-id="element-156" />
                <div className="absolute inset-0 bg-bg-primary/40" data-id="element-157" />
                <div className="relative z-10 text-center" data-id="element-158">
                  <p className="text-white font-bold tracking-widest text-xs bg-bg-primary/80 px-4 py-2 rounded-[8px] border border-border-card" data-id="element-159">
                    FOTO ESTÁTICA
                  </p>
                </div>
              </motion.div>

              <motion.div animate={{
              opacity: step === 1 ? 1 : 0,
              scale: step === 1 ? 1 : 1.05
            }} className="absolute inset-0 flex flex-col items-center justify-center bg-bg-secondary/80 backdrop-blur-md" data-id="element-160">
                <img src="https://cdn.magicpatterns.com/uploads/biwvuFqZDaV6Wzw9WJQ53g/imagem-estattica-imoblabs-1024x1024.png" alt="Procesando" className="absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-overlay" data-id="element-161" />
                <div className="relative z-10 flex flex-col items-center" data-id="element-162">
                  <Sparkles className="w-16 h-16 text-accent mb-4 animate-pulse" data-id="element-163" />
                  <p className="text-accent font-bold tracking-widest text-xs bg-bg-primary/80 px-4 py-2 rounded-[8px] border border-accent-border" data-id="element-164">
                    PROCESANDO CON IA...
                  </p>
                </div>
              </motion.div>

              <motion.div animate={{
              opacity: step === 2 ? 1 : 0,
              scale: step === 2 ? 1 : 1.05
            }} className="absolute inset-0 flex flex-col items-center justify-center bg-bg-primary" data-id="element-165">
                <video src="https://cdn.magicpatterns.com/uploads/qcyLimVjw3zgW2BLEprdmm/Imob Labs IA - RA Films _ Cursos-1.mov" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover opacity-90" data-id="element-166" />
                <div className="absolute inset-0 bg-gradient-to-t from-bg-primary/90 via-transparent to-transparent" data-id="element-167" />
                <div className="relative z-10 text-center mt-auto mb-8" data-id="element-168">
                  <p className="text-white font-bold tracking-widest text-xs bg-bg-primary/80 px-4 py-2 rounded-[8px] border border-border-card inline-block" data-id="element-169">
                    VIDEO CINEMATOGRÁFICO
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}